import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from "vue-property-decorator";
let TemplateContent = class TemplateContent extends Vue {
};
__decorate([
    Prop({ type: Boolean, default: false })
], TemplateContent.prototype, "showHeader", void 0);
TemplateContent = __decorate([
    Component({})
], TemplateContent);
export default TemplateContent;
